// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"108":"fdae4e2039f26b70","115":"7122d06f7f3d8ac9"}[chunkId] + ".js";
};